
define('ldsh!modules/staff/list/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Staff</h1>\n<a class="btn btn-default" href="#/staff/create">Create</a>\n<table class="table table-striped">\n\t<thead>\n  \n  <th>\n   username\n  </th>\n  \n  <th>\n   firstName\n  </th>\n  \n  <th>\n   lastName\n  </th>\n  \n  <th>\n   email\n  </th>\n  \n  <th>\n   businessPhone\n  </th>\n  \n  <th>\n   mobilePhone\n  </th>\n  \n  <th>\n   rate\n  </th>\n  \n  <th>\n   lastLogin\n  </th>\n  \n  <th>\n   numberOfLogins\n  </th>\n  \n  <th>\n   signupDate\n  </th>\n  \n  <th>\n   street1\n  </th>\n  \n  <th>\n   street2\n  </th>\n  \n  <th>\n   city\n  </th>\n  \n  <th>\n   state\n  </th>\n  \n  <th>\n   country\n  </th>\n  \n  <th>\n   code\n  </th>\n  \n  <th>\n   officeId\n  </th>\n\n  <th>\n\n  </th>\n    <th>\n\n  </th>\n\t</thead>\n\t<tbody class="Staff-body">\n\t</tbody>\n</table>';

}
return __p
};});

